import { ChangeDetectionStrategy, Component, OnInit, Self } from '@angular/core';
import { FormControlService } from '../form-control.service';
import { ControlValueAccessorImpl } from '../ng-material-impl/control-value-accessor.impl';
import createControlValueAccessorProvider from '../utils/create-control-value-accessor-provider';
import { PasswordFormControlService } from './password-form-control.service';

@Component({
  selector: 'ss-password-form-control',
  templateUrl: './password-form-control.component.html',
  styleUrls: ['./password-form-control.component.css'],
  providers: [
    PasswordFormControlService,
    FormControlService,
    createControlValueAccessorProvider(PasswordFormControlComponent)
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PasswordFormControlComponent extends ControlValueAccessorImpl<string> implements OnInit {

  readonly hideTextSubject = this._passwordFormControlService.hideTextSubject;

  constructor(
    @Self() private _passwordFormControlService: PasswordFormControlService
  ) {

    super()
  }



  ngOnInit(): void {

  }

  toggleVisiblity(evParams: Event) {

    this.hideTextSubject.next(!this.hideTextSubject.value)
    evParams.stopPropagation();
    evParams.preventDefault();
  }


}
